import React, { useEffect, useState } from 'react';
import { Form, InputGroup, Spinner } from 'react-bootstrap';
import { URL } from '../../variables';
import Attention from '../ReusableComponents/Attention';
import { usePreferences } from '../../contexts/PreferencesContext';

const BlockSelect = ({ processo, token, value, onChange }) => {
    const { t } = usePreferences();
    const [blocks, setBlocks] = useState([]);
    const [loading, setLoading] = useState(false);
    const processoId = processo && processo.id;
    const hasBlocks = processo && (processo.has_blocks === true || processo.has_blocks === 1 || processo.has_blocks === '1');

    useEffect(() => {
        if (!processoId || !hasBlocks) {
            setBlocks([]);
            return;
        }

        setLoading(true);
        fetch(`${URL}api/faculdade/get_blocks/${processoId}`, {
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        })
            .then((response) => response.json())
            .then((response) => {
                if (!response.errors && !response.error) {
                    setBlocks((response.blocks || []).filter((block) => block.type !== 'interval'));
                }
            })
            .catch(() => setBlocks([]))
            .finally(() => setLoading(false));
    }, [processoId, hasBlocks, token]);

    if (!hasBlocks) return null;

    return (
        <InputGroup>
            <div className="flex fdcolumn flex1 margin-bottom">
                <Form.Label>
                    {t('block_select_label')} <Attention />
                    {loading && <Spinner animation="border" size="sm" className="ms-2" />}
                </Form.Label>
                <Form.Control
                    as="select"
                    value={value || ''}
                    onChange={(event) => onChange(event.target.value)}
                    required
                    disabled={loading}
                >
                    <option value="">{t('block_select_option')}</option>
                    {blocks.map((block) => (
                        <option key={block.id} value={block.id}>
                            {block.name} ({block.duration_minutes} min)
                        </option>
                    ))}
                </Form.Control>
                {!loading && blocks.length === 0 && (
                    <small className="badge badge-danger error-message-badge mt-2">
                        {t('block_select_empty')}
                    </small>
                )}
            </div>
        </InputGroup>
    );
};

export default BlockSelect;
